module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/calendarioGray.fc8c2d01.svg";